import { render } from "./HelpApelido.vue?vue&type=template&id=14d58588&scoped=true"
import script from "./HelpApelido.vue?vue&type=script&lang=js"
export * from "./HelpApelido.vue?vue&type=script&lang=js"

import "./HelpApelido.vue?vue&type=style&index=0&id=14d58588&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d58588"]])

export default __exports__